import { render, staticRenderFns } from "./transport-edit-tab.vue?vue&type=template&id=a4bb338a&scoped=true"
import script from "./transport-edit-tab.vue?vue&type=script&lang=js"
export * from "./transport-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./transport-edit-tab.vue?vue&type=style&index=0&id=a4bb338a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bb338a",
  null
  
)

export default component.exports